// SFMA board, listed on the SFMA page.
export const sfmaBoard = [
  { name: "Scott Stecken", role: "President" },
  { name: "Skip Patterson", role: "Vice President" },
  { name: "Paul Orr", role: "Treasurer" },
  { name: "Dee Orr", role: "Secretary" },
  { name: "Ike Manobla", role: "Director of Arts" },
  { name: "Clay Roesle", role: "Member at Large" },
  { name: "Ben Billings", role: "Member at Large" },
];
